import { Alert, Platform } from 'react-native';

// Cross-platform alert implementation
const showAlert = (title, message, buttons = [{ text: 'OK' }]) => {
  if (Platform.OS === 'web') {
    // For web, use browser's native alert
    if (buttons.length === 1) {
      // Simple alert
      window.alert(`${title}\n\n${message}`);
      if (buttons[0].onPress) buttons[0].onPress();
    } else {
      // Confirmation dialog
      const confirmed = window.confirm(`${title}\n\n${message}`);
      
      // Find the appropriate button to trigger based on user's choice
      const confirmButton = buttons.find(btn => btn.style !== 'cancel');
      const cancelButton = buttons.find(btn => btn.style === 'cancel');
      
      if (confirmed && confirmButton && confirmButton.onPress) {
        confirmButton.onPress();
      } else if (!confirmed && cancelButton && cancelButton.onPress) {
        cancelButton.onPress();
      }
    }
  } else {
    // For mobile, use React Native's Alert
    Alert.alert(title, message, buttons);
  }
};

export default {
  showAlert
};